import { ErrorHandler } from '@angular/core';
import { InjectorModule } from './shared/modules/injector.module';
import { BuildInfoCheckService } from './shared/services/build-info-check.service';
import { DatadogRumService } from './shared/services/datadog.service';

export class GlobalErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(e: unknown) {
    //The ResizeObserver loop error is now silently ignored in GlobalErrorHandler
    // it won't be logged to console or sent to Datadog.
    if (this.isResizeObserverLoopError(e)) return;
    console.error(e);
    const dataDogRumService = InjectorModule.injector.get(DatadogRumService);
    const buildInfoCheckService = InjectorModule.injector.get(BuildInfoCheckService);

    if (this.isChunkFailedError(e)) {
      buildInfoCheckService.openDialog('');
    } else {
      dataDogRumService.rum.addError(e);
    }
  }

  private isChunkFailedError(err: any) {
    const chunkFailedMessage = /Loading chunk [\d]+ failed/;
    return chunkFailedMessage.test(err.message);
  }

  private isResizeObserverLoopError(err: any) {
    return typeof err?.message === 'string' && err.message.includes('ResizeObserver loop');
  }
}
